import script from "./DSPProjectDetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DSPProjectDetailModal.vue?vue&type=script&setup=true&lang=ts"

import "./DSPProjectDetailModal.vue?vue&type=style&index=0&id=3da9cc8a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da9cc8a"]])

export default __exports__